import { render, staticRenderFns } from "./VisualizacaoEmpresa.vue?vue&type=template&id=4b05df11"
import script from "./VisualizacaoEmpresa.vue?vue&type=script&lang=js"
export * from "./VisualizacaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./VisualizacaoEmpresa.vue?vue&type=style&index=0&id=4b05df11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports